import { Reducer } from 'redux';
import { HarvestAction, HarvestActions } from '../actions/harvestActions';
import { HarvestState } from '../actions/harvest/types/state';

export const initialState: HarvestState = {
  legacySeasonTagMap: {},
};

const harvestReducer: Reducer<HarvestState, HarvestActions> = (state = initialState, action: HarvestActions) => {
  switch (action.type) {
    case HarvestAction.ReceiveHarvestMetadata: {
      const harvestResults = action.metadata.reduce<HarvestState>((result, season) => {
        const {
          area,
          mass,
          seasonTag,
          yieldAverage,
          dryYieldAverage,
          totalYield,
          standardisedAverageYield,
          legacySeasonTag
        } = season;

        return {
          ...result,
          legacySeasonTagMap: {
            ...result.legacySeasonTagMap,
            [seasonTag]: legacySeasonTag || seasonTag,
          },
          [seasonTag]: {
            ...(area.harvest != null ? { area: area.harvest } : {}),
            ...(mass.avgMoisture != null ? { avgMoisture: mass.avgMoisture } : {}),
            ...(yieldAverage != null ? { avgYield: yieldAverage } : {}),
            ...(totalYield != null ? { totalYield } : {}),
            ...(dryYieldAverage != null ? { avgDryYield: dryYieldAverage } : {}),
            ...(standardisedAverageYield != null ? { standardisedAverageYield } : {}),
            ...(mass.dry != null ? { dryMass: mass.dry } : {}),
            ...(mass.wet != null ? { wetMass: mass.wet } : {}),

          },
        };
      }, initialState);

      return {
        ...state,
        ...harvestResults,
      };
    }

    default:
      return state;
  }
}

export default harvestReducer;
